import { http } from "@/config/httpCommon";
import { showResponseErrors } from "../helpers/Helpers";
import router from "../router";
import store from ".";

export default {
  async registerUser({ commit }, payload) {
    let res = await http.post(`company`, payload);
    commit("SET_REGISTER_USER", res.data);
    return res;
  },
  logout() {
    try {
      http
        .get(`logout`)
        .then(() => {
          localStorage.removeItem("user");
          localStorage.removeItem("company");
          localStorage.removeItem("role");
          localStorage.removeItem("access_token");
          router.push("Login");
        })
        .catch((err) => {
          throw new Error(err);
        });
    } catch (err) {
      throw new Error(err);
    }
  },
  async countries({ commit }) {
    let res = await http.get(`countries`);
    commit("ADD_COUNTRIES", res.data.countries);
    return res;
  },
  async factories({ commit }, search = "") {
    let res = await http.get(`factory${search}`);
    commit("ADD_FACTORIES", res.data.data);
    return res;
    // commit('TOTAL_PAGES', res.data.meta.last_page);
  },
  async getUsersList({ commit }, user_type = "") {
    let url = "list-users";
    if (user_type != "") {
      url += `?user_type=${user_type}`;
    }
    let res = await http.get(url);
    return res;
  },
  currencies({ commit }) {
    try {
      return new Promise((resolve, reject) => {
        http
          .get(`currency`)
          .then((res) => {
            commit("SET_CURRENCIES", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    } catch (err) {
      throw new Error(err);
    }
  },
  async addFactory({ commit }, payload) {
    let res = await http.post(`factory`, payload);
    commit("ADD_FACTORY", res.data.data);
    return res;
  },
  async getFactory({ commit }, id) {
    const res = await http.get(`factory/${id}`);
    commit("FACTORY_SKUS", res.data.data.skus);
    return res;
  },
  async updateFactory({ commit }, payload) {
    let res = await http.put(`factory/${payload.id}`, payload.data);
    commit("UPDATE_FACTORY", res.data.data);
    return res;
  },
  deleteFactory({ commit }, payload) {
    try {
      http.delete(`factory/1`, {
        data: {
          factories: payload,
        },
      });
      commit("DELETE_FACTORIES", payload);
    } catch (err) {
      throw new Error(err);
    }
  },
  getFactoryProducts({ commit }, { order_id, order_item_id }) {

    return new Promise((resolve, reject) => {
      http
        .get(`customer-orders/${order_id}${order_item_id ? `?order_item_id=${order_item_id}`:''} `)
        .then((res) => {
          commit("SET_FACTORY_PRODUCTS", res.data.result);
          resolve(res.data.result);
        })
        .catch((err) => {
          showResponseErrors(err);
          reject(err);
        });
    });
  },
  async getSku({ commit }, payload = "") {
    return await http.get(`skuid${payload}`).then((res) => {
      commit("SET_SKU", res.data.data);
      return res;
    });
  },
  async getSkuAgainstCurrencies({ commit }, payload = "") {
    return await http.get(`skuid/currency/${payload}`).then((res) => {
      commit("SET_CURRENCY_SKUS", res.data.result.skus);
      return res;
    });
  },
  async getAllSkuIds({ commit }, product_id = null) {
    let url = "all-skuids";
    if (product_id) url += "/" + product_id;
    return await http.get(url).then((res) => {
      commit("SET_SKU", res.data.data);
      return res;
    });
  },
  async addSku({ commit }, payload) {
    let formData = new FormData();
    formData.append("data", JSON.stringify(payload.data));
    formData.append("file", payload.file);
    formData.append("spec_file", payload.spec_file);
    formData.append("_method", "POST");
    const res = await http.post(`skuid`, formData);
    commit("ADD_SKU", res.data.data);
    return res;
  },
  async editSku({ commit }, payload) {
    let formData = new FormData();
    formData.append("data", JSON.stringify(payload.data));
    formData.append("file", payload.file);
    formData.append("spec_file", payload.spec_file);
    formData.append("_method", "PUT");
    const res = await http.post(`skuid/${payload.data.id}`, formData);
    commit("EDIT_SKU", { id: payload.data.id, data: res.data.data });
    return res;
  },
  async deleteSkus({ commit }, payload) {
    const res = await http
      .delete(`skuid/${payload}`, {
        data: {
          skus: payload,
        },
      })
      .then((res) => {
        if (res.status == 204) {
          commit("DELETE_SKU", payload);
          return res;
        }
      });
    return res;
  },
  async deleteFactorySkus({ commit }, payload) {
    const res = await http.delete(`skuid/1`, {
      data: {
        skus: payload,
      },
    });
    commit("DELETE_FACTORY_SKU", payload);
    return res;
  },
  async getSteps({ commit }) {
    let res = http.get(`productstep`);
    commit("SET_STEPS", res.data.data);
    // commit('SET_SKU', res.data.data);
  },
  async addStep({ commit }, payload) {
    let res = await http.post(`productstep`, {
      name: payload,
    });
    commit("ADD_STEPS", res.data.data);
    return res;
  },
  async deleteStep({ commit }, payload) {
    await http.delete(`productstep/${payload}`);
    commit("DELETE_STEP", payload);
  },
  async getroles({ commit }, payload = "") {
    let res = await http.get(`role` + payload);
    commit("SET_ROLES", res.data);
    return res;
  },
  async addrole({ commit }, payload) {
    let res = await http.post(`role`, payload);
    await commit("ADD_ROLE", res.data);
    return res;
  },
  async deleterole({ commit }, payload) {
    let res = await http.delete(`role/${payload}`);
    commit("DELETE_ROLE", payload);
    return res;
  },
  async updaterole({ commit }, payload) {
    let res = await http.put(`role/${payload.id}`, payload);
    commit("UPDATE_ROLE", res.data);
    return res;
  },
  async getAllFactories({ commit },paylaod="") {
    let res = await http.get(`list-factories`+ (paylaod));
    return res;
  },
  async getCompanyCustomers({ commit }) {
    let res = await http.get(`get-company-customers`);
    return res;
  },
  async getCategories({ commit }, payload) {
    let res = await http.get(`category` + payload);
    commit("SET_CATEGORIES", res.data.data);
    return res;
  },
  async categories({ commit }) {
    let res = await http.get(`getCategories`);
    commit("SET_CATEGORIES", res.data.data);
    return res;
  },
  async defaultCategories({ commit }) {
    let res = await http.get(`get-default-categories`);
    commit("SET_DEFAULT_CATEGORIES", res.data.data);
    return res;
  },
  async addCategory({ commit }, payload) {
    let res = await http.post(`category`, payload);
    commit("ADD_CATEGORY", res.data.data);
    return res;
  },
  async updateCategory({ commit }, payload) {
    let res = await http.post(`category/${payload.id}`, payload.data, {
      headers: { Accept: "application/json" },
    });
    commit("UPDATE_CATEGORY", res.data.data);
    return res;
  },
  async deleteCategory({ commit }, payload) {
    const res = await http
      .delete(`category/1`, {
        data: {
          ids: payload,
        },
      })
      .then((res) => {
        if (res.status == 204) {
          commit("DELETE_CATEGORY", payload);
          return res;
        }
      });
    return res;
  },
  async addDataSource({ commit }, payload) {
    let res = await http.post(`file/upload`, payload);
    if (res.data.override == true) {
      commit("update", [res.data.data, res.data.data.id]);
    } else {
      commit("ADD_FILES", res.data.data);
    }
    return res.data;
  },
  async getFiles({ commit }, payload) {
    let res = await http.get(`files${payload}`);
    commit("SET_FILES", res.data);
    return res.data;
  },
  async getUserFile({ commit }, payload) {
    let res = await http.get(`files/user${payload}`);
    commit("SET_USER_FILES", res.data.data.data);
    return res.data;
  },
  async downloadFile({ commit }, payload) {
    let res = await http.get(`file/download?id=${payload.id}`, {
      responseType: "blob",
    });

    let blob = new Blob([res.data], { type: res.headers["content-type"] });
    let link = document.createElement("a");
    var url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = payload.file_name;
    link.click();
    link.remove();
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 3000);
  },
  async updateColor({ commit }, payload) {
    let res = await http.post(`file/update`, payload);
    commit("update", [res.data.data, res.data.data.id]);
    return res;
  },
  async updateSizes({ commit }, payload) {
    let res = await http.post(`file/update`, payload);
    commit("update", [res.data.data, res.data.data.id]);
    return res;
  },
  async getusers({ commit }, payload = "") {
    let res = await http.get(`users` + payload);
    commit("SET_USERS", res.data.data);
    return res;
  },
  async adduser({ commit }, payload) {
    let res = await http.post(`users`, payload);
    commit("ADD_USER", res.data.user);
  },
  async deleteuser({ commit }, payload) {
    let res = "";
    res = await http.delete(`users/${payload.id}`);
    commit("DELETE_USER", payload.id);
    return res;
  },
  async getCustomers({ commit }, payload = "") {
    let res = await http.get(`customer` + (payload ? payload : ''));
    commit("SET_CUSTOMERS", res.data.data);
    commit("SET_CUSTOMER_WITH_CURRENT_PRODUCT_ASSIGNED", res.data?.customer_ids ? res.data?.customer_ids : []);
    return res;
  },
  async deleteCustomer({ commit }, payload) {
    await http.delete(`customer/${payload}`);
    commit("DELETE_CUSTOMER", payload);
  },
  async updateCustomer({ commit }, payload) {
    await http.put(`customer/${payload.id}`, payload).then((res) => {
      commit("UPDATE_CUSTOMER", res.data.data);
    });
  },
  async createCustomer({ commit }, payload) {
    await http.post(`create/customer`, payload).then((res) => {
      return res;
    });
  },
  async updateuser({ commit }, payload) {
    let res = await http.put(`users/${payload.id}`, payload);
    commit("UPDATE_USER", res.data.user);
    return res;
  },
  async addmodule({ commit }, payload) {
    let res = await http.post(`permission/module`, payload);
    commit("ADD_MODULE", res.data.modules);
    return res;
  },
  async getmodules({ commit }) {
    let res = await http.get(`permission/modules`);
    commit("SET_PermissionModules", res.data);
  },
  async savepermission({ commit }, payload) {
    let res = await http.post(`permission`, payload);
    res.data.data["override"] = 1;
    if (res.data.data.is_menu == 1) {
      commit("SET_PARENT_LABELS", res.data.data);
    }
    if (res.data.data.is_menu == 1) {
      res.data.data.is_menu = "Yes";
    }
    if (res.data.data.is_menu == 0) {
      res.data.data.is_menu = "No";
    }
    commit("ADD_PERMISSION", res.data.data);
    return res;
  },
  async getparentlabel({ commit }) {
    let res = await http.get(`permission?parent_label=1`);
    commit("SET_PARENT_LABELS", res.data);
    return res;
  },
  async getpermissions({ commit }, payload) {
    let res = await http.get(`permission` + payload);
    await commit("SET_PERMISSIONS", res.data.data);
    return res;
  },
  async getrolepermissions({ commit }, payload) {
    let res = await http.get(
      `role/permissions/${payload.id}/${payload.role_id}`
    );
    return res.data;
  },
  async getuserpermissions({ commit }) {
    let res = await http.get(`allpermissionstorole`);
    commit("SET_CURRENT_ROLE_PERMISSIONS", res.data.data);
  },
  async updatePermissions({ commit }, payload) {
    let res = await http.put(`role/${payload.id}`, payload);
    return res;
  },
  async updatepermission({ commit }, payload) {
    let res = await http.put(`permission/${payload.id}`, payload);
    commit("UPDATE_PERMISSION", res.data.permission);
    return res;
  },
  async getnavigation({ commit, getters }, payload) {
    const authToken = getters.isAuthenticated;
    let arr = [];
    let wrapper = {
      _name: "CSidebarNav",
    };
    let {user, permissions} = store.getters

    let accessInvoicePortal = false
    if (user && permissions.includes("stripe-portal-access")) {
      accessInvoicePortal = true
    }
    let childs = [];
    await http.get(`navigation`).then((res) => {
      res.data.result.forEach((data) => {
        let obj = {};
        if (data.children_menu.length == 0) {
          obj._name = "CSidebarNavItem";
          obj.name = data.name;
          obj.to = data.url_path;
          obj.icon = "cil-list";
        } else if (data.children_menu.length > 0) {
          obj._name = "CSidebarNavDropdown";
          obj.name = data.name;
          obj.route = data.url_path;
          obj.icon = "cil-list";
          let inner = [];
          for (let item in data.children_menu) {
            inner.push({
              name: data.children_menu[item].name,
              to: data.children_menu[item].url_path,
            });
          }
          obj.items = inner;
        }
        childs.push(obj);
      });

      // --- Add Companies dropdown if permission exists ---
    if (permissions.includes("view-companies-module")) {
      childs.push({
        _name: "CSidebarNavDropdown",
        name: "Companies",
        icon: "cil-building", // Use a suitable CoreUI icon
        items: [
          {
            name: "All Companies",
            to: "/companies",
          },
          {
            name: "Kickback & Commision",
            href: `${process.env.VUE_APP_NEW_URL}/buying-groups-sales-reps`,
            rel: "noopener noreferrer",
            target: "_blank",
          },
        ],
      });
    }
    
    if (permissions.includes("default-products")) {
      const defaultProducts = {
        _name: "CSidebarNavDropdown",
        name: "Default Products",
        icon: "cil-list", // Use a suitable CoreUI icon
        items: [
         {
            name: "Default Categories",
            href: `${process.env.VUE_APP_NEW_URL}/default-categories`,
            rel: "noopener noreferrer",
            target: "_blank",
          },
          {
            name: "Assign Products",
            to: "/default-products",
          },
          
        ],
      };

       // find index of "Products"
      const productsIndex = childs.findIndex(
        item => item.name === 'Products'
      )

      // insert right after "Products"
      if (productsIndex !== -1) {
        childs.splice(productsIndex + 1, 0, defaultProducts)
      } else {
        // fallback: push at end if Products not found
        childs.push(defaultProducts)
      }
    }


     
    if (permissions.includes("resellers-management")) {
      const resellersManagement = {
        _name: "CSidebarNavDropdown",
        name: "Resellers Management",
        icon: "cil-list", // Use a suitable CoreUI icon
        items: [
         {
            name: "Resellers",
            href: `${process.env.VUE_APP_NEW_URL}/resellers-management`,
            rel: "noopener noreferrer",
            target: "_blank",
          },
        ],
      };

       // find index of "Acl Management"
      const aclManagementIndex = childs.findIndex(
        item => item.name === 'Acl Management'
      )

      // insert right after "Acl Management"
      if (aclManagementIndex !== -1) {
        childs.splice(aclManagementIndex + 1, 0, resellersManagement)
      } else {
        // fallback: push at end if Products not found
        childs.push(resellersManagement)
      }
    }


      wrapper._children = [
        permissions.includes("access-new-dashboard") && {
          _name: "CSidebarNavItem",
          name: "Dashboard - New",
          href: `${process.env.VUE_APP_NEW_URL}/?access_token=${authToken}`,
          rel: "noopener noreferrer",
          icon: "cil-list",
        },
        ...childs,
        permissions.includes("generate-drawing-sheet") && {
          _name: "CSidebarNavItem",
          name: "Generate Drawing Sheet",
          href: `${process.env.VUE_APP_TDS_LINK}/?auth=${authToken}`,
          rel: "noopener noreferrer",
          icon: "cil-list",
        }, 
        accessInvoicePortal && {
          _name: "InvoicePortalLink",
        },

      ].filter(Boolean);

      arr.push(wrapper);
    });
    await commit('SET_NAVIGATION', wrapper);
     return arr;
  },

  async handleInvoicePortalClick() {
    console.log('click')
    try {
      const response = await http.post(`${process.env.VUE_APP_API_URL}/create-invoice-portal-session`);
      const { url } = response.data;
      window.open(url, '_blank');
    }
    catch (error) {
      console.error('Error creating invoice portal session:', error);
      this.showResponseErrors('Failed to redirect to the Invoice Portal. Please try again later.');
    }
  },
  async deletepermission({ commit }, payload) {
    let res = await http.get(`navigation/delete?id=${payload}`);
    return res;
  },
  async removeProductStyle(_, payload) {
    let res = await http.post("delete/style", payload);
    return res;
  },
  async saveConfiguration({ commit }, payload) {
    const res = await http.post(`save-configuration`, payload);
    return res;
  },
  async saveUIBranding(_, payload) {
    const res = await http.post(`save-ui-branding`, payload);
    return res;
  },
  async fetchUiBranding({ commit }) {
    const res = await http.get(`get-ui-branding`);
    commit("SET_UI_BRANDING", res.data.result.value);
    return res;
  },
  async fetchGoogleFonts({ commit }) {
    const res = await http.get('get-google-fonts');
    return res.data.result;
  },
  async generateApiKey({ commit }) {
    let res = await http.get(`generate-api-key`);
    return res;
  },
  async revokeApiKey({ commit }) {
    let res = await http.get(`revoke-api-key`);
    return res;
  },
  async deleteConfiguration({ commit }, payload) {
    const res = await http.get(`delete-configuration/${payload}`);
    return res;
  },
  async getConfigurations({ commit }, type) {
    const res = await http.get(`get-configurations`);
    return res;
  },
  async getConfiguration({ commit }, type) {
    const res = await http.get(`get-configuration/${type}`);
    return res;
  },
  async verifySMTPSettings({ commit }, payload) {
    const res = await http.post(`verify-smtp-settings`, payload);
    return res;
  },
  async verifySendgridSettingsAndSave({ commit }, payload) {
    const res = await http.post(`sendgrid-verification-settings`, payload);
    return res;
  },
  async sendgridSenderVerification({ commit }, payload) {
    const res = await http.post(`sendgrid-sender-verification`, payload);
    return res;
  },
  async sendSendgridTestMail({commit}, payload) {
    const res = await http.post(`sendgrid-send-test-mail`, payload);
    return res;
  },
  async getTranslations({ commit }, payload = "") {
    return await http.get(`company-translations${payload}`).then((res) => {
      commit("SET_TRANSLATION", res.data.data);
      return res;
    });
  },
  async updateOrderFactory(_, payload) {
    try {
      const { order_id } = payload;
      const res = await http.put(`order/${order_id}/update-factory`, payload);
      return res;
    } catch (error) {
      console.error("Failed to update the order factory:", error);
      throw error;
    }
  },
  async verifySharepoint({ commit }, payload) {
    return await http.post(`verify-sharepoint`, payload).then((res) => {
      return res;
    });
  },
};
